import { Controller } from '@hotwired/stimulus'

const SAFETY = 2 // undershoot a hair so sub-pixel rounding can't tip into an outer scrollbar

export default class extends Controller {
  static targets = ['grid']

  connect() {
    this.adjustHeight()

    // The grid's top isn't final on connect (banners/headers above it settle a frame later, and
    // Turbo renders reconnect without a full reload), so recompute once layout has settled.
    this.frame = requestAnimationFrame(() => this.adjustHeight())

    // Recompute when the scrolling container resizes (window/sidebar). Setting the grid's height
    // changes the container's scrollHeight but not its own box, so there's no feedback loop.
    this.resizeObserver = new ResizeObserver(() => this.adjustHeight())
    this.resizeObserver.observe(this.scrollContainer ?? document.documentElement)

    // A mode change replaces the header frame beside the grid (and shows/hides the search bar)
    // without resizing the container, so re-measure whenever a sibling is swapped in.
    this.mutationObserver = new MutationObserver(() => this.adjustHeight())
    this.mutationObserver.observe(this.element.parentElement, { childList: true })
  }

  disconnect() {
    cancelAnimationFrame(this.frame)
    this.resizeObserver.disconnect()
    this.mutationObserver.disconnect()
  }

  adjustHeight() {
    const container = this.scrollContainer
    // Fit the grid to the container's visible content area — clientHeight excludes its own
    // horizontal scrollbar — so the footer sits on the viewport's bottom edge without an outer scrollbar.
    const visibleBottom = container
      ? container.getBoundingClientRect().top + container.clientHeight
      : window.innerHeight
    const available = Math.max(350, Math.floor(visibleBottom - this.gridTarget.getBoundingClientRect().top) - SAFETY)
    this.gridTarget.style.height = `${available}px`
  }

  get scrollContainer() {
    return this.element.closest('.page__content-container')
  }
}
